var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArchive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33341 5.66383C3.19674 5.6603 3.09749 5.65239 3.00826 5.63464C2.34711 5.50313 1.83028 4.9863 1.69877 4.32515C1.66675 4.16415 1.66675 3.97055 1.66675 3.58333C1.66675 3.19612 1.66675 3.00251 1.69877 2.84152C1.83028 2.18037 2.34711 1.66354 3.00826 1.53202C3.16926 1.5 3.36287 1.5 3.75008 1.5H16.2501C16.6373 1.5 16.8309 1.5 16.9919 1.53202C17.653 1.66354 18.1699 2.18037 18.3014 2.84152C18.3334 3.00251 18.3334 3.19612 18.3334 3.58333C18.3334 3.97055 18.3334 4.16415 18.3014 4.32515C18.1699 4.9863 17.653 5.50313 16.9919 5.63464C16.9027 5.65239 16.8034 5.6603 16.6667 5.66383M8.33342 9.83333H11.6667M3.33341 5.66667H16.6667V12.5C16.6667 13.9001 16.6667 14.6002 16.3943 15.135C16.1546 15.6054 15.7721 15.9878 15.3017 16.2275C14.7669 16.5 14.0669 16.5 12.6667 16.5H7.33342C5.93328 16.5 5.23322 16.5 4.69844 16.2275C4.22803 15.9878 3.84558 15.6054 3.6059 15.135C3.33341 14.6002 3.33341 13.9001 3.33341 12.5V5.66667Z",
    stroke: "currentColor",
    strokeWidth: "1.5px",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.46a5859a35b2136e9f7385e985b13ea5.svg";
export { ForwardRef as ReactComponent };